import { Controller } from 'react-hook-form';
import { RadioCardLegendGroup } from '@fasstech/middle-design-system';
import { useEffect } from 'react';

const ControlledRadioCardLegendGroup = ({
  name,
  form,
  rules,
  isDisplayed = true,
  ...extraProps
}) => {
  if (!isDisplayed) {
    return null;
  }
  useEffect(() => {
    form.trigger(name);
    return () => {
      form.clearErrors(name);
    };
  }, [form.trigger, form.clearErrors, name]);
  return (
    <Controller
      name={name}
      control={form.control}
      rules={rules}
      render={(props) => {
        return (
          <RadioCardLegendGroup
            name={name}
            onChange={(v) => {
              props.field.onChange(v);
            }}
            value={props.field.value}
            {...props}
            {...props.field}
            {...extraProps}
          />
        );
      }}
    />
  );
};

export default ControlledRadioCardLegendGroup;
